import { relayStylePagination } from '@apollo/client/utilities';

import { StrictTypedTypePolicies } from '../__generated__/apollo-helpers';

export const typePolicies: StrictTypedTypePolicies = {
	User: {
		fields: {
			posts: relayStylePagination(),
			notifications: relayStylePagination(),
			conversations: {
				keyArgs: false,
				merge(existing = [], incoming, { args }) {
					const offset = args?.offset ?? 0;
					const merged = existing ? existing.slice(0) : [];

					for (let i = 0; i < incoming.length; ++i) {
						merged[offset + i] = incoming[i];
					}

					const seen = new Set<string>();

					return merged.filter((item) => {
						const id = item.__ref || item.id;
						if (seen.has(id)) return false;
						seen.add(id);

						return true;
					});
				},
			},
		},
	},
	Conversation: {
		fields: {
			messages: relayStylePagination(),
		},
	},
	Post: {
		fields: {
			selectedUsers: {
				merge: false,
			},
		},
	},
	CommunityGroup: {
		fields: {
			posts: relayStylePagination(),
		},
	},
	InformationFeed: {
		fields: {
			posts: relayStylePagination(),
		},
	},
};
